import { render, staticRenderFns } from "./ClaimStatusBadge.vue?vue&type=template&id=714dc3f4"
import script from "./ClaimStatusBadge.vue?vue&type=script&lang=js"
export * from "./ClaimStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports